/**
 * Service for product API calls
 */
import { apiClient } from "./Api";
import { Product } from "@authentic-labs/vue-component-library";
import { ProductDTO } from "@/models/Product";
import products from "@/store/modules/products";

export async function fetchProducts(companyId: number, params?: object) {
  const { data: response } = await apiClient.get(`/api/companies/${companyId}/products`, { params });
  // return products.map((product) => new Product(product));
  return {
    products: response.products.map((product: Product) => new Product(product)),
    productCount: response.productCount,
  };
}

export async function fetchAllProducts(companyId: number) {
  const { data: response } = await apiClient.get(`/api/companies/${companyId}/products/fetchAll`);
  return response.products;
}

export async function fetchProduct(companyId: number, productId: number) {
  // ?
  const { data: product } = await apiClient.get<Product>(`/api/companies/${companyId}/products/${productId}`);
  return new Product(product);
}

export async function fetchLinkedVariants(companyId: number, productId: number) {
  const { data: response } = await apiClient.get(`/api/companies/${companyId}/products/${productId}/linked-variants`);
  return response.variants.map((variant: Product) => new Product(variant));
}

export async function updateProduct(companyId: number, productId: number, payLoad: object) {
  const { data: product } = await apiClient.put<Product>(`/api/companies/${companyId}/products/${productId}`, payLoad);
  return product;
}

export async function createProduct(companyId: number, payLoad: Partial<Product>) {
  const productDto = ProductDTO.create(payLoad);
  const { data: products } = await apiClient.post<Product[]>(`/api/companies/${companyId}/products`, productDto);
  return products;
}

export async function publishProduct(product: Product, payLoad: object) {
  const { data: dates } = await apiClient.put(product.publishUrl, payLoad);
  return dates;
}

export async function copyProduct(companyId: number, payLoad: { productId: number; isVariant?: boolean; sharesContent?: boolean }) {
  const body: Record<string, unknown> = { productId: payLoad.productId };
  if (payLoad.isVariant) {
    body.isVariant = true;
  }
  if (payLoad.sharesContent) {
    body.sharesContent = true;
  }
  const { data: product } = await apiClient.post(`/api/companies/${companyId}/products/copy`, body);
  return product;
}

export async function deleteProduct(companyId: number, productId: number) {
  const { data: response } = await apiClient.delete(`/api/companies/${companyId}/products/${productId}`);
  return response;
}
